document.addEventListener('click',function(e){
const a=e.target.closest('[data-free-advice]');
if(a){
const root=a.closest('.product__section');
const es=document.documentElement.lang.startsWith('es');
const title=a.dataset.adviceTitle||root?.querySelector('h1')?.textContent.trim()||document.title;
const names=JSON.parse(a.dataset.adviceOptions||'[]');
const defaults=JSON.parse(a.dataset.adviceValues||'[]');
const checked=root?Array.from(root.querySelectorAll('.swatches__form--input:checked')):[];
const lines=[es?'Hola JEMSI, quiero asesoría GRATIS.':'Hi JEMSI, I would like FREE advice.',(es?'Producto: ':'Product: ')+title];
if(a.dataset.adviceDefault!=='true'){
names.forEach((name,i)=>{
const input=checked.find(x=>x.name.toLowerCase()===name.toLowerCase())||checked[i];
const value=input?.value||defaults[i];
const n=name.toLowerCase();
const label=/^(size|talla|tamaño)$/.test(n)?(es?'Talla':'Size'):/^(color|colour)$/.test(n)?'Color':name;
if(value&&value!=='Default Title')lines.push(label+': '+value);
});
}
const url=new URL(a.dataset.adviceUrl,location.origin);
url.search='';url.hash='';
lines.push((es?'Ver producto: ':'View product: ')+url.href);
a.href='https://wa.me/18045835108?text='+encodeURIComponent(lines.join('\n'));
}
if(e.target.closest('[data-size-guide]')){let d=document.querySelector('.jemsi-guide-dialog');if(!d){d=document.createElement('dialog');d.className='jemsi-guide-dialog';const es=document.documentElement.lang.startsWith('es');d.innerHTML='<button type="button" data-close-guide style="float:right;background:white;border:0;font-size:24px" aria-label="Close">×</button><h2>'+(es?'Guía de tallas':'Size guide')+'</h2><p>'+(es?'Mide busto, cintura y cadera con una cinta métrica, sin apretar. Las tallas pueden variar según la marca y el modelo. Escríbenos con tus medidas para ayudarte a elegir la talla de este producto.':'Measure your bust, waist and hips without pulling the tape tight. Sizes vary by brand and style. Send us your measurements for help choosing this product’s size.')+'</p>';document.body.append(d)}d.showModal()}
if(e.target.closest('[data-close-guide]'))e.target.closest('dialog').close();
});
document.querySelectorAll('.product__section .product__description--base a[href*="wa.me/"],.product__section .product__decription-container a[href*="wa.me/"]').forEach(a=>{if(!a.hasAttribute('data-free-advice'))a.hidden=true});
